import { render, staticRenderFns } from "./ReceiverAdd.vue?vue&type=template&id=748b7a46&"
import script from "./ReceiverAdd.vue?vue&type=script&lang=ts&"
export * from "./ReceiverAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports